









import { defineComponent } from 'vue';
import { useSearchExecution } from '../../composables/global_search/useSearchExecution';
import SearchResults from '../searches/SearchResults.vue';
import GlobalSearchResultsEmpty from './GlobalSearchResultsEmpty.vue';

export default defineComponent({
  name: 'GlobalSearchResults',
  components: { GlobalSearchResultsEmpty, SearchResults },
  setup() {
    const { isLoading, results, mediaResults, totalCount } = useSearchExecution();
    return { isLoading, results, mediaResults, totalCount };
  },
});
